import { Link } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Logo from 'ui-component/Logo';
import AuthFooter from 'ui-component/cards/AuthFooter';
import LoginLogo from 'assets/images/auth/login logo.png';
import LoginImage from 'assets/images/auth/login image.png';

// assets
import AuthWrapper2 from './authentication/AuthWrapper2';
import AuthCardWrapper from './authentication/AuthCardWrapper';
import AuthLogin from './authentication/auth-forms/AuthLogin';
import { useTheme } from '@mui/material';
import { ThemeMode } from 'config';

// carousel items
const items = [
    {
        title: 'Components Based Design System',
        description: 'Powerful and easy to use multipurpose theme'
    },
    {
        title: 'Ready to use components',
        description: 'Ready made component to apply directly'
    },
    {
        title: 'Multiple dashboard and widgets',
        description: '100+ widgets and customize controls'
    }
];

// ================================|| AUTH2 - LOGIN ||================================ //

export const UnifiedLogin = () => {
    const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

    const { palette } = useTheme();
    const isDarkMode = palette.mode === ThemeMode.DARK;

    return (
        <AuthWrapper2>
            <Grid container justifyContent={{ xs: 'center', md: 'space-between' }} alignItems="center">
                <Grid item md={6} lg={5} sx={{ position: 'relative', alignSelf: 'stretch', display: { xs: 'none', md: 'block' } }}>
                    <Grid
                        sx={{ minHeight: '100vh' }}
                        container
                        alignItems={{ xs: 'center', md: 'flex-start' }}
                        justifyContent={{ xs: 'center', md: 'space-between' }}
                    >
                        <Grid item sx={{ display: { xs: 'none', md: 'block' }, m: 3 }}>
                            <Link to="#" aria-label="theme logo">
                                <Logo />
                            </Link>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            container
                            justifyContent="center"
                            alignItems="center"
                            sx={{ minHeight: { xs: 'calc(100vh - 68px)', md: 'calc(100vh - 152px)' } }}
                        >
                            <Stack justifyContent="center" alignItems="center" spacing={5} m={2}>
                                <Box component={Link} to="#" sx={{ display: { xs: 'block', md: 'none' } }}>
                                    <Logo />
                                </Box>
                                <Grid container spacing={2} justifyContent="center">
                                    <img src={LoginLogo} width={200} alt="login logo" />
                                    <img src={LoginImage} alt="login banner" />
                                </Grid>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sx={{ m: 3 }}>
                            <AuthFooter />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} lg={7} xs={12} sx={{ minHeight: '100vh' }}>
                    <Grid
                        sx={{ minHeight: '100vh' }}
                        container
                        alignItems={{ xs: 'center', md: 'center' }}
                        justifyContent={{ xs: 'center', md: 'space-between' }}
                    >
                        <Grid
                            item
                            xs={12}
                            container
                            justifyContent="center"
                            alignItems="center"
                            sx={{ minHeight: { xs: 'calc(100vh - 68px)', md: 'calc(100vh - 152px)' } }}
                        >
                            <Stack justifyContent="center" alignItems="center" spacing={5} m={2}>
                                <Box component={Link} to="#" sx={{ display: { xs: 'block', md: 'none' } }}>
                                    <Logo />
                                </Box>
                                <AuthCardWrapper border={downLG}>
                                    <Grid container spacing={2} justifyContent="start">
                                        <Grid item>
                                            <Stack alignItems="flex-start" justifyContent="flex-start" spacing={1}>
                                                <Typography gutterBottom variant={downMD ? 'h3' : 'h2'}>
                                                    Welcome back
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    className={`text-gray-${isDarkMode ? 400 : 600}`}
                                                    fontSize="16px"
                                                    textAlign={downMD ? 'center' : 'inherit'}
                                                >
                                                    Welcome back! Please enter your details.
                                                </Typography>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <AuthLogin loginProp={2} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                        {/* <Grid item xs={12}>
                                            <Grid item container direction="column" alignItems="center" xs={12}>
                                                <Typography
                                                    component={Link}
                                                    to="/pages/register/register2"
                                                    variant="subtitle1"
                                                    sx={{ textDecoration: 'none' }}
                                                >
                                                    Don&apos;t have an account?
                                                </Typography>
                                            </Grid>
                                        </Grid> */}
                                    </Grid>
                                </AuthCardWrapper>
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </AuthWrapper2>
    );
};
